(function ($) {
    $(document).ready(function () {
        // fixing accessibility issues with the events calendar plugin
        let section = document.getElementsByTagName("section");
        for (var i = 0; i < section.length; i++) {
            if (section[i].id == "tribe-events-pg-template") {
                section[i].setAttribute("aria-label", "event");
            }
        }
    });
    // WP Facets - Hide Wrapper if no filter options exist
    document.addEventListener('facetwp-loaded', function () {
        const tabletWidth = window.matchMedia("(min-width: 768px)");
        $.each(FWP.settings.num_choices, function (key, val) {
            var $facet = $('.facetwp-facet-' + key);
            var $parent = $facet.closest('.facet-wrap');
            var $flyout = $facet.closest('.flyout-row');
            if ($parent.length || $flyout.length) {
                var $which = $parent.length ? $parent : $flyout;
                (0 === val) ? $which.hide() : $which.show();

                // Add check for .collapse element
                var $collapseElement = $facet.closest('.collapse');
                if ($collapseElement.length > 0) {  // Only proceed if element exists
                    try {
                        var bsCollapse = bootstrap.Collapse.getOrCreateInstance($collapseElement[0], { toggle: false });
                        if (tabletWidth.matches) {
                            bsCollapse.show();
                        } else {
                            bsCollapse.hide();
                        }
                    } catch (error) {
                        console.warn('Bootstrap Collapse initialization failed:', error);
                    }
                }
            }
        });
    });

    // WP Facets - Hide Reset Button if no facets are selected
    $(document).on('facetwp-loaded', function () {
        var querystring = FWP.buildQueryString();
        if ('' === querystring) {
            $('.facet-reset').hide();
        }
        else {
            $('.facet-reset').show();
        }
    });

    // WP Facets - Hide Reset for search if empty
    $(document).on('facetwp-loaded', function () {
        var facetSearch = FWP.facets['search'];
        if (facetSearch && facetSearch.length <= 0) {
            $('.facet-btn-search-reset').hide();
        } else {
            $('.facet-btn-search-reset').show();
        }
    });

    function isFacetPagerAtEnd() {
        if (typeof window.FWP === 'undefined' || !FWP.settings || !FWP.settings.pager) {
            return false;
        }
        var page = parseInt(FWP.settings.pager.page, 10);
        var total = parseInt(FWP.settings.pager.total_pages, 10);
        return !isNaN(page) && !isNaN(total) && page >= total;
    }

    function updateFacetListingLoadMore() {
        $('.program-listing-pager, .news-listing-pager, .post-listing-pager, .person-listing-pager, .awards-listing-pager').each(function () {
            var $pager = $(this);
            var $toggle = $pager.find('.program-listing-load-more, .news-listing-load-more, .post-listing-load-more, .person-listing-load-more, .awards-listing-load-more');
            var $facetButton = $pager.find('.facetwp-load-more');
            var hasLoadMore = $facetButton.length > 0 && !$facetButton.prop('disabled');

            // FacetWP's pager state is the authoritative end-of-results signal:
            // the hidden .facetwp-load-more inside an inert wrapper isn't reliably
            // flagged as disabled by the time facetwp-loaded fires.
            if (hasLoadMore && isFacetPagerAtEnd()) {
                hasLoadMore = false;
            }

            $pager.toggle(hasLoadMore);
            $toggle
                .prop('disabled', !hasLoadMore)
                .attr('aria-expanded', 'false')
                .removeAttr('aria-busy');
        });
    }

    $(document).on('click', '.program-listing-load-more, .news-listing-load-more, .post-listing-load-more, .person-listing-load-more, .awards-listing-load-more', function () {
        var $toggle = $(this);
        var $pager = $toggle.closest('.program-listing-pager, .news-listing-pager, .post-listing-pager, .person-listing-pager, .awards-listing-pager');
        var $facetButton = $pager.find('.facetwp-load-more');

        if (!$facetButton.length || $facetButton.prop('disabled') || isFacetPagerAtEnd()) {
            updateFacetListingLoadMore();
            return;
        }

        $toggle
            .attr('aria-expanded', 'true')
            .attr('aria-busy', 'true');
        $facetButton.trigger('click');
    });

    $(document).on('facetwp-loaded', updateFacetListingLoadMore);
    $(updateFacetListingLoadMore);
})(jQuery);
// END WP Facets

// START Person Popover
document.addEventListener('DOMContentLoaded', function () {
    // Options for the Bootstrap Popover.
    const popoverOptions = {
        html: true,
        trigger: 'hover focus',
        placement: 'top',
        container: 'body',
        delay: { show: 200, hide: 300 },
        sanitize: false,
        content: function() {
            // Use the pre-rendered content from the data attribute
            return this.dataset.personContent || '';
        },
    };

    /**
     * Initializes a popover on a given element.
     * @param {HTMLElement} el The element to attach the popover to.
     */
    function initPopover(el) {
        // Mark the element as having an initialized popover so we only do this once.
        el.dataset.popoverInitialized = 'true';
        
        // Add ARIA attributes for accessibility
        el.setAttribute('aria-haspopup', 'true');
        
        // Create the popover
        new bootstrap.Popover(el, popoverOptions);
        
        // Add a more descriptive accessible label
        const personName = el.textContent.trim();
        el.setAttribute('aria-label', personName + ' - Press Enter for profile details');
    }

    // Initialize popovers for all person links on page load
    const personLinks = document.querySelectorAll('a[rel="person-popover"]');
    personLinks.forEach(link => {
        initPopover(link);
    });

    // Use event delegation to attach the popover to any `person-popover` link,
    // even those added to the page dynamically.
    document.body.addEventListener('mouseenter', function (event) {
        const link = event.target.closest('a[rel="person-popover"]');
        if (link && link.dataset.popoverInitialized !== 'true') {
            initPopover(link);
        }
    }, true); // Use capture phase to ensure our listener runs first.
});
// END Person Popover

// START Modal Focus Fix
// Fix Bootstrap aria-hidden timing issue for modals with data-bs-focus="false"
// Focus is set manually after the modal is fully shown (aria-hidden removed)
// Uses event delegation to handle modals rendered in footer or added dynamically
document.addEventListener('shown.bs.modal', function(event) {
    const modal = event.target;
    // Only handle modals with disabled auto-focus
    if (modal.hasAttribute('data-bs-focus') && modal.getAttribute('data-bs-focus') === 'false') {
        // Find the first focusable element in the modal
        const focusable = modal.querySelector(
            '.coe-close-btn, [data-bs-dismiss="modal"], .btn-close, ' +
            'button:not([disabled]), a[href], input:not([disabled]), ' +
            'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );
        if (focusable) {
            focusable.focus();
        }
    }
});
// END Modal Focus Fix

// START Header Search Focus
// The desktop search lives in a Bootstrap dropdown; move focus into the
// field when it opens so keyboard users can type immediately (issue #49).
document.addEventListener('shown.bs.dropdown', function (event) {
    if (event.target && event.target.id === 'dropdownSearchButton') {
        const searchInput = document.getElementById('header-search-input');
        if (searchInput) {
            searchInput.focus();
        }
    }
});
// END Header Search Focus

// START CSE Search Page Focus
// /search/ embeds Google Programmable Search; move focus into its input
// once the widget injects so the pre-filled query is ready to refine
// (issue #52, Approach B). Widget injection is async and races our
// deferred script, and Google may replace the input node after we focus
// it — so: try immediately, hook the CSE ready-callback, and keep a
// MutationObserver alive for a 10s window that re-focuses only when a
// node replacement dropped focus back to <body> (never when the user
// moved focus somewhere else on purpose).
(function () {
    const cseHost = document.querySelector('#___gcse_0, .gcse-search, .gcse-searchbox, .gcse-searchbox-only');
    if (!cseHost) {
        return;
    }
    let focusedInput = null;
    function focusCseInput() {
        const input = document.querySelector('input.gsc-input');
        if (!input) {
            return false;
        }
        input.focus();
        if (document.activeElement === input) {
            focusedInput = input;
            return true;
        }
        return false;
    }
    function needsFocus() {
        // Only ever take focus when it is sitting on <body> (page arrival,
        // or Google swapped out the node we focused). If the user has put
        // focus anywhere real — skip link, nav, the input itself — leave it.
        const active = document.activeElement;
        if (active !== document.body && active !== null) {
            return false;
        }
        return !focusedInput || !focusedInput.isConnected;
    }
    if (needsFocus()) {
        focusCseInput();
    }
    if (!focusedInput) {
        window.__gcse = window.__gcse || {};
        const previousCallback = window.__gcse.callback;
        window.__gcse.callback = function () {
            if (typeof previousCallback === 'function') {
                previousCallback();
            }
            if (needsFocus()) {
                focusCseInput();
            }
        };
    }
    const cseObserver = new MutationObserver(function () {
        if (needsFocus()) {
            focusCseInput();
        }
    });
    cseObserver.observe(document.body, { childList: true, subtree: true });
    // Stop watching after 10s: by then the widget is stable, and the
    // observer shouldn't run forever if Google fails to load.
    setTimeout(function () {
        cseObserver.disconnect();
    }, 10000);
})();
// END CSE Search Page Focus
